<template>
<div id="kt_header" class="header header-fixed" :style="topBarColor">
	<div class="container-fluid  d-flex align-items-stretch justify-content-between">
		<div class="header-menu-wrapper header-menu-wrapper-left" id="kt_header_menu_wrapper">
			<div id="kt_header_menu" class="header-menu header-menu-mobile header-menu-layout-default">
				<ul class="menu-nav">
					<li class="menu-item  font-size-h5">
						{{ brand_name }}
					</li>
				</ul>
			</div>
		</div>
		<div class="topbar">
			<template v-if="store.state.brand?.plan?.description?.toLowerCase().includes('platinum')">
				<ChatIcon 
					class="topbar-item mr-4" 
					style="cursor: pointer;" 
					svg-color="secondary"
					svg-title="OrderCircle Chats" 
					:unread-count="totalUnreadCount"
					@click="toggleDrawer"
				/>
				<Drawer :is-drawer-active="isDrawerActive" :drawer-title="`OrderCircle Chats`"
					@hideDrawerToggle="hideDrawer">
					<template #drawerContent>
						<div class="card-body p-0">
							<chat />
						</div>
					</template>
					<template #drawerOverlay>
						<ChatBox style="margin-right: 500px;" v-for="(user, index) in openChats" :key="index" :index="index" :user="user"
							:position="index" />
					</template>
				</Drawer>
			</template>
			<Notifications></Notifications>
			<div class="dropdown">
				<div class="dropdown" id="kt_quick_search_toggle">
					<div class="topbar-item" data-toggle="dropdown" data-offset="10px,0px">
							<div class="btn btn-icon btn-clean btn-lg btn-dropdown mr-1">
								<span class="svg-icon svg-icon-xl svg-icon-primary" id="search_icon">
									<!--begin::Svg Icon | path:assets/media/svg/icons/General/Search.svg-->
									<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
										<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
											<rect x="0" y="0" width="24" height="24" />
											<path d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" />
											<path d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z" fill="#000000" fill-rule="nonzero" />
										</g>
									</svg>
									<!--end::Svg Icon-->
								</span>
							</div>
						</div>
					<div class="dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim-up dropdown-menu-lg">
						<div class="quick-search quick-search-dropdown" id="">
							<form class="quick-search-form" onsubmit="return false">
								<div class="input-group">
									<div class="input-group-prepend">
										<span class="input-group-text">
											<span class="svg-icon svg-icon-lg">
												<!--begin::Svg Icon | path:assets/media/svg/icons/General/Search.svg-->
												<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
													<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
														<rect x="0" y="0" width="24" height="24" />
														<path d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" />
														<path d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z" fill="#000000" fill-rule="nonzero" />
													</g>
												</svg>
												<!--end::Svg Icon-->
											</span>
										</span>
									</div>
									<input id="search_field" type="text" @keyup.enter="searchFilter" v-model="searchQuery" 
										   class="form-control" placeholder="Search Orders and Customers..." />
									<div class="input-group-append">
										<span class="input-group-text">
											<i class="quick-search-close ki ki-close icon-sm text-muted"></i>
										</span>
									</div>
								</div>
							</form>
							<div class="quick-search-wrapper scroll" data-scroll="true" data-height="325"
								data-mobile-height="200"></div>
						</div>
					</div>
				</div>
			</div>
			<div class="topbar-item">
				<AccountDetails></AccountDetails>
			</div>
		</div>
	</div>
</div>
</template>
<script setup>
import { ref, computed, onMounted, onBeforeMount } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import AccountDetails from '@/js/ordercircle/brands/layouts/accountdetails.vue';
import Notifications from '@/js/ordercircle/brands/layouts/notifications.vue';
import ChatIcon from '@/js/svgs/chat-icon.vue';
import Drawer from '@/js/theme/components/drawer.vue';
import chat from '@/js/theme/components/chats/index.vue'
import ChatBox from '@/js/theme/components/chats/box.vue'
import { setUserStatus, getUnreadMessagesCount } from '@/js/utils/firebase';

const store = useStore();
const router = useRouter();
const brand_name = computed(() => store.getters.brand['brand_name']);
const searchQuery = ref('');
const openChats = computed(() => store.getters['openChats']);
const totalUnreadCount = ref(0);
const isDrawerActive = ref(false);

const topBarColor = computed(() => ({
	'background-color': store.state.brand_skins['topbar_bg_color'],
}));

// Set up real-time listener for unread messages
onMounted(() => {
  const type = store.getters.role;
  const id = store.getters.user.user.role?.id;
  const mappedType = type === 'staff' ? 'staffs' : type === 'customer' ? 'customers' : type;
  const userKey = `${mappedType}-${id}`;
  const brandId = store.getters.brand?.id;

  // Listen for unread messages count changes
  getUnreadMessagesCount(brandId, userKey, (count) => {
    totalUnreadCount.value = count;
  });
});

const toggleDrawer = () => {
	isDrawerActive.value = !isDrawerActive.value;

	if (isDrawerActive.value) {
		const type = store.getters.role.split('-')[0];
		const id = store.getters.user.user.role?.id;
		const mappedType = type === 'staff' ? 'staffs' : type === 'customer' ? 'customers' : type;

		setUserStatus({ type: mappedType, id }, 1, true);
	}
};

const logout = (e) => {
	e.preventDefault();
	window.localStorage.removeItem('access_token');
	router.push('/logout');
};
const searchFilter = () => {
	router.push({ name: 'search', params: { query: searchQuery.value } });
	searchQuery.value = '';
};

const hideDrawer = () => {
	isDrawerActive.value = false;

	const type = store.getters.role;
    const brandId = store.getters.brand?.id;
	const id = store.getters.user.user.role?.id;
	const mappedType = type === 'staff' ? 'staffs' : type === 'customer' ? 'customers' : type;
	setUserStatus({ type: mappedType, id }, brandId, false);
};

</script>
<style scoped>
.topbar-item{
	display: flex;
	align-items: center;
}
.user-card {
	width:700px;
	height:500px;
	overflow-y: auto;
}
.chat-box {
	padding-left: 5px;
	padding-right: 5px;
	cursor: pointer;
}

.chat-box:hover {
	background-color: #f1f1f1;
}
.btn.btn-clean i {
	color: #B5B5C3 !important;
}

@media (min-width: 992px) {

	.header-menu .menu-nav>.menu-item {
		background-color: #fff !important;
		border-radius: 3px;
	}
}
</style>
